export default __webpack_public_path__ + "static/media/№ KZ.T.07.E0719.cedaedde.svg";